import { render, staticRenderFns } from "./lotteryIndex.vue?vue&type=template&id=a372f90a&scoped=true&"
import script from "./lotteryIndex.vue?vue&type=script&lang=js&"
export * from "./lotteryIndex.vue?vue&type=script&lang=js&"
import style0 from "./lotteryIndex.vue?vue&type=style&index=0&id=a372f90a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a372f90a",
  null
  
)

export default component.exports